// SponsorsGrid: Grid for sponsors on public home page
import React from 'react';
import { Grid, Box, Typography, useTheme } from '@mui/material';

const sponsors = [
  { name: 'TechCorp', logo: '/assets/sponsor1.png' },
  { name: 'BizGroup', logo: '/assets/sponsor2.png' }
];

function SponsorsGrid() {
  const theme = useTheme();
  return (
    <Grid container spacing={2} sx={{ my: 4 }}>
      {sponsors.map((sponsor) => (
        <Grid item xs={6} sm={4} md={3} key={sponsor.name}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <Box sx={{
              width: { xs: 84, sm: 96, md: 120 },
              height: { xs: 84, sm: 96, md: 120 },
              borderRadius: '50%',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: theme.palette.mode === 'dark' ? '#23272f' : '#ffffff',
              border: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.06)'}`,
              boxShadow: theme.palette.mode === 'dark' ? '0 6px 20px rgba(0,0,0,0.6)' : '0 8px 30px rgba(2,6,23,0.06)',
              transition: 'transform 220ms ease, box-shadow 220ms ease',
              '&:hover': { transform: 'scale(1.06)', boxShadow: theme.palette.mode === 'dark' ? '0 10px 36px rgba(0,0,0,0.7)' : '0 12px 40px rgba(2,6,23,0.12)' },
            }}>
              <Box component="img" src={sponsor.logo} alt={sponsor.name} sx={{ width: '70%', height: '70%', objectFit: 'contain', transition: 'transform 320ms ease', '&:hover': { transform: 'scale(1.12)' } }} />
            </Box>
            <Typography variant="subtitle2" sx={{ mt: 0.5, fontSize: { xs: '0.85rem', sm: '0.95rem' }, fontWeight: 700, textAlign: 'center' }}>{sponsor.name}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default SponsorsGrid;
